function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
module.exports = /******/function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/
  var installedModules = {};
  /******/
  /******/ // The require function
  /******/
  function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/
    var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/
    };
    /******/
    /******/ // Execute the module function
    /******/
    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/
    module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/
    return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/
  __webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/
  __webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/
  __webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, {
        enumerable: true,
        get: getter
      });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/
  __webpack_require__.r = function (exports) {
    /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/Object.defineProperty(exports, Symbol.toStringTag, {
        value: 'Module'
      });
      /******/
    }
    /******/
    Object.defineProperty(exports, '__esModule', {
      value: true
    });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/
  __webpack_require__.t = function (value, mode) {
    /******/if (mode & 1) value = __webpack_require__(value);
    /******/
    if (mode & 8) return value;
    /******/
    if (mode & 4 && _typeof(value) === 'object' && value && value.__esModule) return value;
    /******/
    var ns = Object.create(null);
    /******/
    __webpack_require__.r(ns);
    /******/
    Object.defineProperty(ns, 'default', {
      enumerable: true,
      value: value
    });
    /******/
    if (mode & 2 && typeof value != 'string') for (var key in value) __webpack_require__.d(ns, key, function (key) {
      return value[key];
    }.bind(null, key));
    /******/
    return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/
  __webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ? /******/function getDefault() {
      return module['default'];
    } : /******/function getModuleExports() {
      return module;
    };
    /******/
    __webpack_require__.d(getter, 'a', getter);
    /******/
    return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/
  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/
  __webpack_require__.p = "";
  /******/
  /******/
  /******/ // Load entry module and return exports
  /******/
  return __webpack_require__(__webpack_require__.s = 6);
  /******/
}
/************************************************************************/
/******/([/* 0 */
/***/function (module, exports) {
  module.exports = require("@xo-union/event-target-shim");

  /***/
}, /* 1 */
/***/function (module, exports) {
  module.exports = require("customevent");

  /***/
}, /* 2 */
/***/function (module, exports) {
  module.exports = require("@babel/runtime-corejs3/core-js/promise");

  /***/
},

  /* 3 */
  /* 4 */
  /* 5 */
,,, /* 6 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  // ESM COMPAT FLAG
  __webpack_require__.r(__webpack_exports__);

  // EXPORTS
  __webpack_require__.d(__webpack_exports__, "PageletContainer", function () {
    return (/* reexport */PageletContainer_PageletContainer
    );
  });
  __webpack_require__.d(__webpack_exports__, "RemotePagelet", function () {
    return (/* reexport */RemotePagelet_RemotePagelet
    );
  });

  // EXTERNAL MODULE: external "@xo-union/event-target-shim"
  var event_target_shim_ = __webpack_require__(0);

  // CONCATENATED MODULE: ./src/core/PageletContainer/CustomEvent.js
  // eslint-disable-next-line func-style, prefer-arrow/prefer-arrow-functions
  function CustomEvent() {
    // Defer requiring customevent to avoid runtime issue in nodejs
    // eslint-disable-next-line global-require
    var Constructor = __webpack_require__(1);
    for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }
    return _construct(Constructor, params);
  }

  /* harmony default export */
  var PageletContainer_CustomEvent = CustomEvent;
  // CONCATENATED MODULE: ./src/core/PageletContainer/createContainerContext/index.js
  var createContainerContext = function createContainerContext(pageletContainer) {
    return {
      // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
      get mountNode() {
        return pageletContainer.mountNode;
      },
      // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
      get props() {
        return pageletContainer.props;
      },
      addEventListener: function addEventListener() {
        pageletContainer.addEventListener.apply(pageletContainer, arguments);
      },
      removeEventListener: function removeEventListener() {
        pageletContainer.removeEventListener.apply(pageletContainer, arguments);
      },
      pageletDidRender: function pageletDidRender() {
        pageletContainer.mountNode.setAttribute('data-pagelet-render-state', 'ready');
      },
      pageletDidUnrender: function pageletDidUnrender() {
        pageletContainer.mountNode.removeAttribute('data-pagelet-render-state');
      }
    };
  };

  /* harmony default export */
  var PageletContainer_createContainerContext = createContainerContext;
  // CONCATENATED MODULE: ./src/core/PageletContainer/index.js

  // Simple prepend ponyfill

  var prepend = function prepend(parent, child) {
    if (typeof parent.prepend === 'function') {
      parent.prepend(child);
      return;
    }
    parent.insertBefore(child, parent.firstChild);
  };
  var isRendered = function isRendered(pageletContainer) {
    return pageletContainer.mountNode.getAttribute('data-pagelet-render-state') === 'ready';
  };
  var emitErrorEvent = function emitErrorEvent(pageletContainer, _ref) {
    var cancelable = _ref.cancelable,
      detail = _ref.detail;
    var errorEvent = new PageletContainer_CustomEvent('error', {
      cancelable: cancelable,
      detail: _objectSpread({
        isRendered: isRendered(pageletContainer)
      }, detail)
    });
    return pageletContainer.dispatchEvent(errorEvent);
  };
  var evaluatePageletScript = function evaluatePageletScript(scriptElement, containerContext) {
    /* eslint-disable no-new-func */
    var source = scriptElement.innerHTML;
    var exec = new Function('pageletContainer', "'use strict';".concat(source));
    exec.call({}, containerContext);
  };
  var PageletContainer_PageletContainer = /*#__PURE__*/function (_event_target_shim_$E) {
    _inherits(PageletContainer_PageletContainer, _event_target_shim_$E);
    var _super = _createSuper(PageletContainer_PageletContainer);
    function PageletContainer_PageletContainer(id) {
      var _this;
      _classCallCheck(this, PageletContainer_PageletContainer);
      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        errorPagelet = _ref3.errorPagelet,
        props = _ref3.props;
      _this = _super.call(this);
      _this.id = id;
      _this.errorPagelet = errorPagelet;
      _this.props = props;
      _this.mountNode = null;
      _this.willMount = null;
      _this.currentPagelet = null;
      _this.wasPrepared = false;
      /**
       * Data passed to children
       */

      _this.containerContext = PageletContainer_createContainerContext(_assertThisInitialized(_this));
      return _this;
    }
    _createClass(PageletContainer_PageletContainer, [{
      key: "prepare",
      value: function prepare() {
        if (this.wasPrepared) {
          return;
        }
        var rootNode = document.body.querySelector("[data-pagelet-container-id=\"".concat(this.id, "\"]"));
        var pageletScriptElement = rootNode.querySelector('script[type="text/x-union-pagelet-script"]');
        var mountNode = rootNode.querySelector('[data-pagelet-role="mount-root"]');
        if (!mountNode) {
          mountNode = document.createElement('div');
          mountNode.setAttribute('data-pagelet-role', 'mount-root');
          prepend(rootNode, mountNode);
        }
        if (pageletScriptElement) {
          evaluatePageletScript(pageletScriptElement, this.containerContext);
        }
        this.mountNode = mountNode;
        this.wasPrepared = true;
      }
    }, {
      key: "mount",
      value: function mount(pagelet) {
        var _this2 = this;
        if (!this.wasPrepared) {
          this.prepare();
        }
        this.willMount = pagelet;
        this.dispatchEvent(new PageletContainer_CustomEvent('will-load', {
          detail: {
            pagelet: pagelet
          }
        }));
        pagelet.load().then(function () {
          /**
           * Cancel mounting if unmount was called or if mount was called consecutively with different pagelets
           */
          if (_this2.willMount !== pagelet) {
            return;
          }
          _this2.currentPagelet = pagelet;
          pagelet.mount(_this2.containerContext);
          _this2.willMount = null;
        }, function (error) {
          // eslint-disable-next-line no-console
          console.error(error);
          var notCanceled = emitErrorEvent(_this2, {
            cancelable: true,
            detail: {
              phase: 'load',
              error: error
            }
          });
          if (notCanceled) {
            _this2.errorPagelet.mount(_this2.containerContext);
          }
        });
      }
    }, {
      key: "unmount",
      value: function unmount() {
        this.willMount = null;
        if (!this.currentPagelet) {
          // eslint-disable-next-line no-console
          console.warn('Called PageletContainer#unmount with no mounted pagelet');
          return;
        }
        this.currentPagelet.unmount(this.containerContext);
        this.currentPagelet = null;
      }
    }, {
      key: "setProps",
      value: function setProps(newProps) {
        var event = new PageletContainer_CustomEvent('props', {
          detail: {
            previousProps: this.props,
            props: newProps
          }
        });
        this.props = newProps;
        this.dispatchEvent(event);
      }
    }]);
    return PageletContainer_PageletContainer;
  }(event_target_shim_["EventTarget"]); // EXTERNAL MODULE: external "@babel/runtime-corejs3/core-js/promise"
  var promise_ = __webpack_require__(2);
  var promise_default = /*#__PURE__*/__webpack_require__.n(promise_);

  // CONCATENATED MODULE: ./src/core/RemotePagelet/loadLinks/index.js

  var amdImport = function amdImport(dependencies) {
    return new promise_default.a(function (resolve, reject) {
      var handleError = function handleError(error) {
        reject(error);
      };
      var handleSuccess = function handleSuccess() {
        for (var _len = arguments.length, _exports = new Array(_len), _key = 0; _key < _len; _key++) {
          _exports[_key] = arguments[_key];
        }
        resolve(_exports);
      };
      window.UNION_INTERNAL_MODULE_SYSTEM.require(dependencies, handleSuccess, handleError);
    });
  };

  /* harmony default export */
  var loadLinks = function loadLinks(_ref) {
    var _ref$links = _ref.links,
      _ref$links2 = _ref$links === void 0 ? {} : _ref$links,
      js = _ref$links2.js,
      css = _ref$links2.css;
    var dependencies = [js.toString()];
    if (css) {
      dependencies.push("css-loader!".concat(css));
    }
    return amdImport(dependencies).then(function (_ref2) {
      var _ref4 = _slicedToArray(_ref2, 1),
        _exports = _ref4[0];
      return _exports;
    });
  };
  // CONCATENATED MODULE: ./src/core/RemotePagelet/index.js
  var RemotePagelet_RemotePagelet = /*#__PURE__*/function () {
    function RemotePagelet_RemotePagelet() {
      _classCallCheck(this, RemotePagelet_RemotePagelet);
      var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref5$links = _ref5.links,
        links = _ref5$links === void 0 ? {} : _ref5$links,
        _ref5$jsExportName = _ref5.jsExportName,
        jsExportName = _ref5$jsExportName === void 0 ? 'default' : _ref5$jsExportName;
      this.pageletInstance = null;
      this.links = links;
      this.jsExportName = jsExportName;
    }
    _createClass(RemotePagelet_RemotePagelet, [{
      key: "isLoaded",
      get: function get() {
        return !!this.pageletInstance;
      }
    }, {
      key: "load",
      value: function load() {
        var _this3 = this;
        return loadLinks({
          links: this.links
        }).then(function (exports) {
          _this3.pageletInstance = exports[_this3.jsExportName];
        });
      }
    }, {
      key: "mount",
      value: function mount(params) {
        return this.pageletInstance.mount(params);
      }
    }, {
      key: "unmount",
      value: function unmount(params) {
        return this.pageletInstance.unmount(params);
      }
    }]);
    return RemotePagelet_RemotePagelet;
  }(); // CONCATENATED MODULE: ./src/core/index.js
  /***/
}
/******/]);